import React from "react";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";

import FormControl from "@material-ui/core/FormControl";

import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
function RegularButton({ ...props }) {
  const {
    onChange,
    classes,
    label,
    value,
    listData,
    // ...rest
  } = props;
  return (
    <FormControl
      fullWidth
      className={classes.selectFormControl}
    >
      <InputLabel
        htmlFor="simple-select"
        className={classes.selectLabel}
      >
        <b>{label}</b>
      </InputLabel>
      <Select
        MenuProps={{
          className: classes.selectMenu
        }}
        classes={{
          select: classes.select
        }}
        value={value}
        inputProps={{
          name: "simpleSelect",
          id: "simple-select",
          onChange: onChange
        }} 
      >
        {
          listData.map((DataCue, index) => (
            <MenuItem key={"select" + index}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected
              }}
              value={DataCue.value}
            >
              {DataCue.name}
            </MenuItem>
          ))
        }

      </Select>
    </FormControl>
  );
}

export default withStyles(extendedFormsStyle)(RegularButton);
